import React from "react";
import { useLoaderData } from "react-router";
import TwoColumnLayout from "layout/TwoColumnLayout";
import DocumentV1NewEditSection from "./DocumentV1NewEditSection";
import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";

export const DocumentV1NewApp = () => {
  const viewModel = useLoaderData<server.viewmodel.DocumentV1NewFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <DocumentV1NewEditSection
        documentType={viewModel.documentType}
        artistRiders={viewModel.artistRiders}
      />
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>
      <GeneralOptionsPanel
        data={viewModel.optionsPanel}
        links={[{ text: RESX.Buttons.ListView, visible: true, href: viewModel.listUrl }]}
      />
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>
};

export default DocumentV1NewApp;
